export enum DataChangedEventType {
	ADDED,
	CHANGED,
	DELETED
}
